import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {
  componentDidMount() {
    window.document.documentElement.scrollTop = 0
  }

  render() {
    return (
      <div className="agreement">
 <h1>Terms of Use</h1>
<br />
<strong>Notes</strong><br />
The operator of "App" (hereinafter referred to as "we") advises users to read this Terms of Use (hereinafter referred to as "the Agreement") carefully and ensure complete understanding before registering. By registering, logging in, or using the Services, you are deemed to have accepted all terms in this Agreement and agree to be bound by them. If you do not agree, you are not authorized to use the Services.
<br /><br />
This Agreement defines the rights and obligations between App and users regarding the App software and services ("the Service"). A "user" refers to individuals who register, log in, or use the Service. If we update the Agreement, and you do not accept the changes, please stop using the Service immediately. Continued use means acceptance of the updated terms.
<br /><br />
<h3>I. Account Registration</h3>
1. Users must register an "App" account before accessing the Service. The account should be linked to a phone number or third-party service not already associated with another App account or blocked.<br />
2. Users logging in with Snapchat must be over 18 years old.
<br /><br />
<h3>II. Service Content</h3>
1. App offers features such as messaging, friend adding, group joining, room creation, and voice chatting. These features may change at any time.<br />
2. Services may be free or paid. Paid services require users to purchase virtual currency (Gold Coins) through approved payment methods. Coins can then be used per App’s pricing schedule. App will notify users before any charges. Payment is considered complete upon confirmation from the payment platform or bank.
<br /><br />
<h3>III. Personal Information Protection</h3>
1. App is committed to protecting user data.<br />
2. Users may need to provide information such as phone numbers, avatars, or device data to access services. App protects this data using encryption, anonymization, and secure storage.<br />
3. See the App Privacy Policy for more details.<br />
4. To delete your data:
<br />
- Go to: Me > Feedback and submit a request<br />
- Or use: <b>Me > Settings > Delete Account</b>
<br /><br />
<h3>IV. Content Regulation</h3>
1. User content includes profile data, messages, voice chat, and content generated while using the Service.<br />
2. Users may not publish content that:
<br />
- Is sexually explicit<br />
- Abusive or threatening<br />
- Includes spam or malicious/deceptive content<br />
- Violates privacy or contains personal data of others<br />
- Infringes intellectual property or legal rights<br />
- Disrupts services or harms others
<br /><br />
<h3>V. Virtual Currency</h3>
1. App provides virtual currency ("Gold Coins") for use on paid features. Coins cannot be used elsewhere.<br />
2. Users must confirm account details before topping up. Errors due to user input will not be compensated.<br />
3. Coins cannot be refunded, converted to legal tender, or transferred unless legally required.<br />
4. Coins cannot be traded outside App. Suspicious behavior may result in usage restrictions.<br />
5. App may modify transaction rules for security and other needs.<br />
6. Paid services cannot be refunded or exchanged unless otherwise required by law.<br />
7. Users are responsible for losses due to:
<br />
- Account loss, bans, or freezes<br />
- Sharing passwords<br />
- Third-party payment errors<br />
- Misuse by others
<br />
8. App may ban accounts for violations. Coins may be frozen or forfeited. No refunds will be issued.
<br /><br />
<h3>VI. Account Management</h3>
1. App owns all accounts. Registered users receive limited use rights, which are non-transferable.<br />
2. Users may manage personal data via the "My" page. Deleted content cannot be recovered.<br />
3. Users are responsible for securing their credentials. Misuse is the user’s liability.<br />
4. App may suspend or terminate services for violations, with notice.
<br /><br />
<h3>VII. Intellectual Property</h3>
1. All service content (e.g., pages, text, images, audio, video) is owned by App unless otherwise stated.<br />
2. All software used in the Service is the property of App.<br />
3. Logos, trademarks, and brand identifiers belong to App and cannot be used without written permission.<br />
4. All IP owned by App or advertisers is legally protected. Derivative works require prior written consent.
<br /><br />
<h3>VIII. Legal Entity</h3>
Legal Entity: YAYYA TECHNOLOGY LIMITED<br />
Address: Mongkok, KLN, Kowloon City District, Hong Kong

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/termsofuse/index.js